exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.loader-popup{position:absolute;top:calc(50% - 81px);left:calc(50% - 160px);height:163px;width:320px;background:#fff;border-radius:4px;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);display:flex;flex-direction:column;align-items:center;justify-content:center}.loader-popup__text{font-family:Open Sans,sans-serif;font-size:20px;font-style:italic;text-align:center;color:#9b9b9b;margin-bottom:20px}.loader-popup .lds-ellipsis{zoom:.7}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/LoaderPopup/LoaderPopup.scss
// module id = 1576
// module chunks = 0